import type { NotificationContentProps } from '@/utils/hooks/context/toast/types';

// Components
import NewContentAutomaticAlbum from '@/components/composite/Notifications/Content/Albums/NewContentAutomaticAlbum';

const NotificationsContent = ({ notification }: NotificationContentProps) => {
    const type = notification.type;
    switch (type) {
        case 'new_content_automatic_album':
            return <NewContentAutomaticAlbum notification={notification} />;
        default:
            return null;
    }
};

export default NotificationsContent;
